/**
 * @packageDocumentation
 * @module HackerAPI
 */
import * as Utils from "../utils/utils";
/**
 * @class
 */
var Base = /** @class */ (function () {
    /**
     * Every data container that holds data that can be sent off to hackerapi should inherit this
     * @param specialHandlers
     */
    function Base(specialHandlers) {
        if (specialHandlers === void 0) { specialHandlers = {}; }
        this.specialHandlers = specialHandlers;
    }
    /**
     * Converts a Javascript date (where only day, month and year are relevant) to a format understood by hackerapi
     * @param key
     * @param date - Doesn't do anything if string
     * @returns key: [0], value: [1]
     */
    Base.dateHandler = function (key, date) {
        return [
            Utils.underscores(key),
            typeof date === "object" ? date.toISOString().substr(0, 10) : date
        ];
    };
    /**
     * Converts Javascript date to a format understood by hackerapi
     * @param key
     * @param date - If given a string then it assumes it is in the right formats
     * @returns key: [0], value: [1]
     */
    Base.dateTimeHandler = function (key, datetime) {
        return [
            Utils.underscores(key),
            typeof datetime === "object" ? datetime.toISOString() : datetime
        ];
    };
    /**
     * Does not send the field to hackerapi
     * @param key
     * @param value
     * @returns key: [0], value: [1]
     */
    Base.doNotSendHandler = function (key, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _ // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return [key, undefined];
    };
    /**
     * HOC for renaming a field before sending it to hackerapi
     * @param renamedKey - The string to rename the key to
     * @returns key: [0], value: [1]
     */
    Base.renameHandler = function (renamedKey) {
        return function (_originalKey, value) {
            return [renamedKey, value];
        };
    };
    /**
     * Converts an object to hackerapi object notation
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Base.prototype.toHackerAPIFormat = function (method) {
        // This is some fucked up code but it works
        var _this = this;
        var r = {};
        Object.keys(this).forEach(function (key) {
            try {
                if (key !== "specialHandlers" &&
                    key !== "createdAt" &&
                    key !== "updatedAt") {
                    if (_this.specialHandlers[key]) {
                        var _a = _this.specialHandlers[key](key, _this[key], method), k = _a[0], v = _a[1];
                        r[k] = v;
                    }
                    else if (_this[key] !== null && typeof _this[key] === "object") {
                        if (Array.isArray(_this[key])) {
                            var ukey_1 = Utils.underscores(key);
                            r[ukey_1] = [];
                            _this[key].forEach(function (e) {
                                r[ukey_1].push("toHackerAPIFormat" in e ? e.toHackerAPIFormat(method) : e);
                            });
                        }
                        else {
                            r[Utils.underscores(key)] =
                                _this[key] && _this[key].toHackerAPIFormat
                                    ? _this[key].toHackerAPIFormat(method)
                                    : _this[key];
                        }
                    }
                    else if (_this[key] !== null) {
                        r[Utils.underscores(key)] = _this[key];
                    }
                }
                // eslint-disable-next-line no-empty
            }
            catch (e) { }
        });
        return r;
    };
    return Base;
}());
export default Base;
//# sourceMappingURL=base.js.map